import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Card, Tooltip, Typography } from 'antd';

import { EChargeType } from 'interfaces/IEditProduct';
import type IProduct from 'interfaces/IProduct';

type SectionMoreProps = {
  product: IProduct;
};

function SectionMore({ product }: SectionMoreProps) {
  return (
    <>
      <Card className='h-full'>
        <div className='flex flex-col gap-3'>
          <img src='/img/icon_psl.svg' width='40' alt='' />
          <Typography.Text strong>Configure o PSL</Typography.Text>
          <Typography.Paragraph>
            Agora você pode configurar os planos para que seus clientes tenham a liberdade e flexibilidade de escolha.
          </Typography.Paragraph>
          <div>
            <Link id='link-go-to-psl' to={`/producer/product/editproduct/${product.id}/paymentmethods`}>
              <Button id='new-product-preview-configure-psl'>Configurar</Button>
            </Link>
          </div>
        </div>
      </Card>

      <Card className='h-full'>
        <div className='flex flex-col gap-3'>
          <img src='/img/icon_offer.svg' width='40' alt='' />
          <Typography.Text strong>Crie ofertas</Typography.Text>
          <Typography.Paragraph>
            Você pode criar ofertas para todos os planos, tornando-os mais atrativos para seus clientes.
          </Typography.Paragraph>
          <div>
            <Link id='link-go-to-offer' to={`/producer/product/editproduct/${product.id}/sales`}>
              <Button id='new-product-preview-create-offer'>Criar oferta</Button>
            </Link>
          </div>
        </div>
      </Card>

      <Card className='h-full'>
        <div className='flex flex-col gap-3'>
          <img src='/img/icon_affiliate.svg' width='40' alt='' />
          <Typography.Text strong>Comissões para afiliados</Typography.Text>
          <Typography.Paragraph>
            Configure a porcentagem que seu afiliado receberá por cada plano vendido.
          </Typography.Paragraph>
          <div>
            <Tooltip
              placement='top'
              title={
                product.charge_type === EChargeType.FREE
                  ? 'O recurso de afiliado está indisponível para produtos gratuitos'
                  : ''
              }
            >
              <Link id='link-go-to-affiliate' to={`/producer/product/editproduct/${product.id}/affiliates`}>
                <Button id='new-product-preview-affiliate' disabled={product.charge_type === EChargeType.FREE}>
                  Habilitar comissão
                </Button>
              </Link>
            </Tooltip>
          </div>
        </div>
      </Card>
    </>
  );
}

export default SectionMore;
